import { render, staticRenderFns } from "./RegisterChita.vue?vue&type=template&id=10496524"
import script from "./RegisterChita.vue?vue&type=script&lang=js"
export * from "./RegisterChita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports